import * as types from "./types"; 

import {getBudgetListAxios, postBudgetListAxios, updateBudgetListAxios, deleteBudgetListAxios, getBudgetByIdListAxios} from  "./services";

export async function getBudgetListAction({ commit }, id) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await getBudgetListAxios(id);
        commit(types.GET_BUDGET_LIST, data.result);
        return data.result;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}


export async function getBudgetByIdListAction({ commit }, id) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await getBudgetByIdListAxios(id);
        commit(types.GET_BUDGET_BY_ID, data.result);
        return data;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}

export async function postBudgetAction({ commit }, payload) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await postBudgetListAxios(payload);
        commit(types.POST_BUDGET, data.result);
        return data;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}

export async function updateBudgetAction({ commit }, payload) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await updateBudgetListAxios(payload);
        commit(types.UPDATE_BUDGET, data.result);
        return data;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}

export async function deleteBudgetAction({ commit }, id) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await deleteBudgetListAxios(id);
        commit(types.DELETE_BUDGET, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}